import axios from "axios";
import { logout } from "../utils/auth";

const axiosClient = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL || "/api",
    withCredentials: true, // <--- THIS ensures all requests have credentials
});

// No need for: axios.defaults.withCredentials = true; (can remove it)

// Request interceptor: attach access token
axiosClient.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Response interceptor: handle 401 errors and refresh token
axiosClient.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;
        if (
            error.response?.status === 401 &&
            !originalRequest._retry
        ) {
            originalRequest._retry = true;
            try {
                const refreshToken = localStorage.getItem("refreshToken");
                if (!refreshToken) throw new Error("No refresh token");
                const response = await axios.post(
                    `${process.env.REACT_APP_API_BASE_URL}/auth/refresh`,
                    { refreshToken },
                    { withCredentials: true } // always add for refresh as well
                );
                const { token: newToken, refreshToken: newRefreshToken } = response.data.data;
                localStorage.setItem("token", newToken);
                localStorage.setItem("refreshToken", newRefreshToken);
                originalRequest.headers.Authorization = `Bearer ${newToken}`;
                return axiosClient(originalRequest);
            } catch (refreshError) {
                logout();
                return Promise.reject(refreshError);
            }
        }
        return Promise.reject(error);
    }
);

export default axiosClient;
